import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import "../FormsMainPage.css";

const Sd2ProposalForm_G: React.FC = () => {
  // State for form data
  const [formData, setFormData] = useState({
    unitNumber: "12345",
    branch: "Branch A",
    district: "District 1",
    khetra: "Kshetra Y",
    zone: "Zone Z",
    sewadalCountMale: "100",
  });

  // Hardcoded data for now
  useEffect(() => {
    const hardcodedData = {
      unitNumber: "12345",
      branch: "Branch A",
      district: "District 1",
      khetra: "Kshetra Y",
      zone: "Zone Z",
      sewadalCountMale: "100",
    };

    setFormData(hardcodedData);
  }, []);

  const [tableData, setTableData] = useState([
    {
      name: "",
      post: "",
      personalNumber: "",
      fatherHusbandName: "",
      dob: "",
      qualification: "",
      occupation: "",
      stampSizePhoto: "",
      note: "",
    },
  ]);

  // Sample members data with dummy images for John
  const membersData = [
    {
      name: "John",
      post: "",
      personalNumber: "PN12345",
      fatherHusbandName: "Doe",
      dob: "1990-05-20",
      qualification: "Graduate",
      occupation: "Teacher",
      stampSizePhoto:
        "data:image/svg+xml;base64,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", // Dummy photo
      note: "",
    },
    {
      name: "Jane",
      post: "",
      personalNumber: "PN54321",
      fatherHusbandName: "Smith",
      dob: "1985-04-18",
      qualification: "Postgraduate",
      occupation: "Engineer",
      stampSizePhoto: "", // No data means the photo needs to be uploaded
      signature: "", // No data means the signature needs to be uploaded
      note: "",
    },
    // Add more members as needed
  ];

  const handleTableChange = (
    index: number,
    e: React.ChangeEvent<
      HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    const updatedTableData = [...tableData];
    if (updatedTableData[index]) {
      updatedTableData[index] = {
        ...updatedTableData[index],
        [name]: value,
      };
      setTableData(updatedTableData);
    }
  };

  const handleNameChange = (
    index: number,
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedName = e.target.value;
    const selectedMember = membersData.find(
      (member) => member.name === selectedName
    );

    const updatedTableData = [...tableData];
    if (updatedTableData[index]) {
      updatedTableData[index] = {
        ...updatedTableData[index],
        ...selectedMember, // Populate the row with the selected member's details
      };
      setTableData(updatedTableData);
    }
  };

  const addRow = () => {
    setTableData([
      ...tableData,
      {
        name: "",
        post: "",
        personalNumber: "",
        fatherHusbandName: "",
        dob: "",
        qualification: "",
        occupation: "",
        stampSizePhoto: "",
        note: "",
      },
    ]);
  };

  const deleteRow = (index: number) => {
    const updatedTableData = tableData.filter((_, i) => i !== index);
    setTableData(updatedTableData);
  };

  const handleFileChange = (index: any, event: any) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const newData = [...tableData];
        newData[index] = {
          ...newData[index],
          [event.target.name]: reader.result, // Save the image data URL
        };
        setTableData(newData);
      };

      reader.readAsDataURL(file);
    }
  };
  const ExsitingAdhikaridata = [
    {
      name: "John Doe",
      post: "Sanchalak",
      personalNumber: "12345",
      fatherName: "Robert Doe",
      dob: "1990-01-01",
      nominatedDate: "2023-10-01",
      note: "",
    },
    {
      name: "Jane Smith",
      post: "Shikshak",
      personalNumber: "67890",
      fatherName: "Michael Smith",
      dob: "1992-02-02",
      nominatedDate: "2023-09-15",
      note: "",
    },
    {
      name: "Emily Johnson",
      post: "Sahayak shikshak",
      personalNumber: "54321",
      fatherName: "William Johnson",
      dob: "1994-03-03",
      nominatedDate: "2023-08-20",
      note: "",
    },
  ];

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    console.log("Table Data:", tableData);
    console.log("ExsitingAdhikaridata", ExsitingAdhikaridata);
  };

  return (
    <div className="container-fluid mt-5">
      <div className="row justify-content-center mt-3">
        <div className="col-12 col-lg-12">
          <div className="card shadow">
            <div className="card-body">
              <legend className="sd2GAdhikariProposal">
                <b>SD-2(Males) Adhikari Proposal Form</b>
              </legend>
              <p>
                Please enter the necessary details for SD-2(Males) Adhikari
                Proposal.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Column 1 */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label htmlFor="unitNumber">Unit Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="unitNumber"
                        value={formData.unitNumber}
                        disabled
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="district">District</label>
                      <input
                        type="text"
                        className="form-control"
                        id="district"
                        value={formData.district}
                        disabled
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="sewadalCountMale">
                        Sewadal Count (Male)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sewadalCountMale"
                        value={formData.sewadalCountMale}
                        disabled
                      />
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label htmlFor="branch">Branch</label>
                      <input
                        type="text"
                        className="form-control"
                        id="branch"
                        value={formData.branch}
                        disabled
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="khetra">Khetra</label>
                      <input
                        type="text"
                        className="form-control"
                        id="khetra"
                        value={formData.khetra}
                        disabled
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="zone">Zone</label>
                      <input
                        type="text"
                        className="form-control"
                        id="zone"
                        value={formData.zone}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <h5>Existing Adhikari Details:</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Post</th>
                        <th>Personal Number</th>
                        <th>Father Name</th>
                        <th>DOB</th>
                        <th>Nominated Date</th>
                        <th>Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ExsitingAdhikaridata.map((item, index) => (
                        <tr key={index}>
                          <td>{item.name}</td>
                          <td>{item.post}</td>
                          <td>{item.personalNumber}</td>
                          <td>{item.fatherName}</td>
                          <td>{item.dob}</td>
                          <td>{item.nominatedDate}</td>
                          <td>{item.note}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="table-responsive">
                  <h5>Names for Adhikari Proposal:</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Post</th>
                        <th>Personal Number</th>
                        <th>Father Name</th>
                        <th>Date of Birth</th>
                        <th>Qualification</th>
                        <th>Occupation</th>
                        <th>Stamp Size Photo on Vardi</th>
                        <th>Note</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <select
                              name="name"
                              value={row.name}
                              onChange={(e) => handleNameChange(index, e)}
                            >
                              <option value="">Select Name</option>
                              {membersData.map((member) => (
                                <option key={member.name} value={member.name}>
                                  {member.name}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <input
                              type="text"
                              name="post"
                              value={row.post}
                              onChange={(e) => handleTableChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="personalNumber"
                              value={row.personalNumber}
                              onChange={(e) => handleTableChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="fatherHusbandName"
                              value={row.fatherHusbandName}
                              onChange={(e) => handleTableChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              name="dob"
                              value={row.dob}
                              onChange={(e) => handleTableChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="qualification"
                              value={row.qualification}
                              onChange={(e) => handleTableChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="occupation"
                              value={row.occupation}
                              onChange={(e) => handleTableChange(index, e)}
                            />
                          </td>
                          <td>
                            {row.stampSizePhoto ? (
                              <img src={row.stampSizePhoto} alt="Stamp Size" />
                            ) : (
                              <input
                                type="file"
                                name="stampSizePhoto"
                                accept="image/*" // Restrict to image formats only
                                onChange={(e) => handleFileChange(index, e)}
                              />
                            )}
                          </td>
                          <td>
                            <input
                              type="text"
                              name="note"
                              value={row.note}
                              onChange={(e) => handleTableChange(index, e)}
                            />
                          </td>
                          <td>
                            <button className="addRow" type="button" onClick={addRow}>
                              <FontAwesomeIcon
                                icon={faPlus}
                                style={{ color: "#007bff" }}
                              />
                            </button>
                            {index > 0 && (
                              <button
                                className="deleteRow"
                                type="button"
                                onClick={() => deleteRow(index)}
                                style={{ marginLeft: "10px" }}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  style={{ color: "red" }}
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sd2ProposalForm_G;
